import axios from 'axios';

export const getMerchant = async (apiKey = "LzQz7C1GCGXzVwCf1EsMlG88GAz7PcCv", queries = null) => {
    
    window.localStorage.clear()
    
    try {
        const merchant = await axios.post("https://merchant.birrionapi.com/api/merchant-info", { apiKey })
        // const website = merchant.data.message.website
        // const domain = website ? `http://${website}`: `https://${merchant.data.message.username}.thebittle.com`

        window.localStorage.setItem("bMerchant", JSON.stringify( merchant.data.message ))

        // this.setState(s => ({
        //   merchantDashboard: `${domain}/`,
        //   frameId: queries.frame,
        //   host: queries.host,
        //   rates: merchant.data.message.buying_at
        // }))
        
        // try {
        //   await axiosInstance.post("/api/v1/widget/activity", { type: "widgetInitialized", frameId: queries.frame, host:queries.host }, {headers:{"x-access-merchant": merchant.data.message.username}})
        // } catch ( err ) {
        //   console.log(err)
        // }

        return merchant.data.message

    } catch( err ) {
        throw err
    }
    
  }